import { css } from 'linaria';
import { ArrowRightIcon } from 'components/icons/ArrowRightIcon';
const linkWrapper = "lwq3eyf";
export const ArrowLink = ({
  href,
  target,
  margin,
  onClick,
  children,
  id,
  dataCy
}) => <a className={linkWrapper} style={{
  margin
}} href={href} target={target} id={id} data-cy={dataCy} onClick={onClick}>
    {children}
    <ArrowRightIcon className="arrow-icon" />
  </a>;

require("./arrow-link.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./arrow-link.js");